import { render, staticRenderFns } from "./LockChassis.vue?vue&type=template&id=30bfe2cf&scoped=true"
import script from "./LockChassis.vue?vue&type=script&lang=js"
export * from "./LockChassis.vue?vue&type=script&lang=js"
import style0 from "./LockChassis.vue?vue&type=style&index=0&id=30bfe2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfe2cf",
  null
  
)

export default component.exports